import ErrorMessage from 'components/ErrorMessage'
import OButton from 'components/reusable/OButton'
import useToastContext from 'hooks/useToastContext'
import React, { useState, useRef } from 'react'
import { useForm } from 'react-hook-form'
import { apiPost } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { useTranslation } from 'react-i18next'
import { AiFillCamera } from 'react-icons/ai'
import OImage from 'components/reusable/OImage'
import { isEmpty } from 'lodash'
import OInputField from 'components/reusable/OInputField'
import defaultAmenity from '../../assets/images/defaultAmenity.png'

const AddAmenity = ({ setShowModal, allAmenities }) => {
  const { t } = useTranslation()
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true
  })
  const notification = useToastContext()
  const [addMerchantLoading, setAddMerchantLoading] = useState(false)
  const [profilePicError, setProfilePicError] = useState('')
  const [profilePic, setProfilePic] = useState(null)
  const profilePicRef = useRef()

  const onSubmit = async data => {
    setAddMerchantLoading(true)
    try {
      if (profilePic == null) {
        setProfilePicError('Please select an icon.')
      } else {
        const formData = new FormData()
        formData.append('name', data.name?.trim())
        formData.append('nameAr', data.nameAr?.trim())
        formData.append('icon', profilePic)

        const path = apiPath.ListAmenities
        const result = await apiPost(path, formData)
        if (result?.data?.success) {
          allAmenities()
          setShowModal(false)
          notification.success(result.data.message)
        } else {
          notification.error(result.data.message)
        }
      }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
    setAddMerchantLoading(false)
  }

  const validateFiles = newProfilePic => {
    let picError = ''
    const supportedTypes = ['image/jpeg', 'image/jpg', 'image/png']

    if (!isEmpty(supportedTypes.includes(newProfilePic.type))) {
      picError = 'Only jpeg, jpg and png are supported.'
    }
    if (picError) {
      setProfilePicError(picError)
      return false
    } else {
      setProfilePicError('')
      return true
    }
  }

  const handleFileChange = e => {
    const image = e?.target?.files[0]
    const isValidImage = validateFiles(image)
    if (isValidImage) {
      setProfilePic(image)
    } else {
      setProfilePic(null)
    }
  }

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative my-6  w-full max-w-[750px] mx-auto'>
          <div className='sm:py-4 sm:px-2 py-8 px-7 '>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('ADD_AMENITIES')}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => setShowModal(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              <div>
                <div className='py-4 flex justify-center'>
                  <div className='relative w-24 h-24 '>
                    <label className='block mb-2 text-sm text-center font-medium text-gray-900 dark:text-white w-28'>
                      {t('O_PHOTO')}
                    </label>
                    <input
                      type='file'
                      accept='image/png, image/jpg, image/jpeg'
                      name='image'
                      ref={profilePicRef}
                      onChange={handleFileChange}
                      className='hidden'
                    />

                    <OImage
                      src={
                        profilePic
                          ? URL.createObjectURL(profilePic)
                          : defaultAmenity
                      }
                      fallbackUrl={defaultAmenity}
                      className='w-24 h-24'
                      alt=''
                      style={{ borderRadius: '50%' }}
                    />
                    <AiFillCamera
                      className=' bg-gray-100  absolute w-4 rounded-xl cursor-pointer'
                      style={{
                        width: '1.5rem',
                        height: '1.5rem',
                        bottom: '-23px',
                        right: 0,
                        background: '',
                        padding: '1px'
                      }}
                      onClick={() => profilePicRef?.current?.click()}
                    />
                  </div>
                </div>
                <div className='text-center mt-4'>
                  <ErrorMessage message={profilePicError} />
                </div>
              </div>

              <div className='relative p-6 flex-auto'>
                <div className=''>
                  <div className='px-2 mt-10'>
                    <OInputField
                      wrapperClassName='relative z-0 mb-6 w-full group max-w-[500px] m-auto'
                      name='name'
                      inputLabel={
                        <>
                          {t('O_NAME')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      autoFocus
                      // maxLength={15}
                      register={register('name', {
                        required: 'Name is required.',
                        minLength: {
                          value: 2,
                          message: 'Minimum length must be 2.'
                        },
                        validate: value => {
                          return value.trim() !== ''
                            ? true
                            : 'White spaces not allowed.'
                        }
                      })}
                      errors={errors}
                    />
                  </div>
                </div>
              </div>
              <div className='px-2 '>
                <OInputField
                  wrapperClassName='relative z-0 mb-6 w-full group max-w-[500px] m-auto'
                  name='nameAr'
                  inputLabel={
                    <>
                      {t('O_NAME') + t('O_ARABIC')}
                      <span className='text-red-500'>*</span>
                    </>
                  }
                  type='text'
                  // maxLength={15}
                  register={register('nameAr', {
                    required: 'Name in arabic is required.',
                    minLength: {
                      value: 2,
                      message: 'Minimum length must be 2.'
                    },
                    validate: value => {
                      return value.trim() !== ''
                        ? true
                        : 'White spaces not allowed.'
                    }
                  })}
                  errors={errors}
                />
              </div>

              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => setShowModal(false)}
                >
                  {t('O_BACK')}
                </button>
                {addMerchantLoading ? (
                  <div className='spinner-container'>
                    {' '}
                    <div className='loading-spinner' />
                  </div>
                ) : (
                  <OButton
                    disabled={!isDirty}
                    label={<>{t('O_ADD')}</>}
                    type='submit'
                    onClick={handleSubmit(onSubmit, () => {
                      if (profilePic == null) {
                        setProfilePicError('Please select an icon.')
                      }
                    })}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default AddAmenity
